function TrustBadges({
  completedSalesCount = 0,
  compact = false,
  ratingAverage = 0,
  ratingCount = 0,
  verified = false,
}) {
  const badges = [
    {
      className: verified ? "verified" : "new",
      label: verified ? "Verificeret" : "Ny sælger",
    },
  ];

  if (ratingCount > 0) {
    badges.push({
      className: "rating",
      label: `${ratingAverage.toFixed(1)} rating`,
    });
  } else if (!compact) {
    badges.push({
      className: "unrated",
      label: "Ingen rating endnu",
    });
  }

  if (completedSalesCount > 0) {
    badges.push({
      className: "sales",
      label: `${completedSalesCount} solgt`,
    });
  }

  return (
    <div className={`trust-badges ${compact ? "compact" : ""}`} aria-label="Sælgerstatus">
      {badges.map((badge) => (
        <span className={`trust-badge ${badge.className}`} key={badge.label}>
          {badge.label}
        </span>
      ))}
    </div>
  );
}

export default TrustBadges;
